angular
  .module('mandaeApp')
  .controller('DocumentoCtrl',
    function($state, FinalizaCadastro, Perfil) {
      'use strict';

      var vm = this;
      vm.showLoading = false;
      vm.documento = {};
      var user = Perfil.getCacheUserData();

      if (user) {
        if (user.cpf) {
          vm.documento.cpfCnpj = user.cpf;
          vm.jaTemDocumento = true;
        } else if (user.cnpj) {
          vm.checkPJ = true;
          vm.documento.cpfCnpj = user.cnpj;
          vm.jaTemDocumento = true;
          if (user.razaoSocial) {
            vm.jaTemRazaoSocial = true;
            vm.documento.razaoSocial = user.razaoSocial;
          }
          if (user.inscricaoEstadual) {
            vm.jaTemInscricaoEstadual = true;
            vm.documento.inscricaoEstadual = user.inscricaoEstadual;
          }
        }
        var userPlan = user.planoContrato && user.planoContrato.tipo && user.planoContrato.tipo.toLowerCase();
        vm.isEnterprisePlan = userPlan === 'freedom';
        vm.checkPJ = user.pj || vm.isEnterprisePlan;
      }

      vm.voltar = function() {
        $state.go('endereco');
      };

      vm.saveDocument = function (form) {
        if (!form.$valid) { return; }

        vm.showLoading = true;

        var request = {
          'cpfCnpj': vm.documento.cpfCnpj,
          'razaoSocial': vm.documento.razaoSocial,
          'inscricaoEstadual': vm.documento.inscricaoEstadual,
        };

        FinalizaCadastro.gravaDocumentos(request)
          .then(function() {
            // parametro true ignora o cache
            Perfil.getUserData(true)
              .then(function(user) {
                vm.showLoading = false;
                $state.go('termos-de-uso', {user: user});
              })
              .catch(function(err) {
                console.log(err);
              });
          }).catch(function(err) {
            console.log(err);
            vm.showLoading = false;
          });
      };
  });
